<template>
  <base-section
  id="theme-features"
  space="20"
  >
    <v-container>
    <base-section-heading
    title="Welcome to LATS2025"
    color="secondary"
    align="left"
    :toColor="true"
    >
The IEEE Latin-American Test Symposium (LATS) is a recognized forum dedicated to presenting and discussing scientific results, emerging ideas, applications, hot topics and new trends in the area of electronic-based circuits and system testing, reliability, and security. LATS is attended by professionals from all over the world, in particular from Latin-America. Accepted papers will be submitted for inclusion into IEEE Xplore subject to meeting IEEE Xplore’s scope and quality requirements. Selected papers of this 26th edition will be invited to re-submit an improved version of the paper to Microelectronics & Reliability (Elsevier), and Journal of Electronic Testing: Theory and Applications (JETTA - Springer).<br /> <br />
Topics of interest include, but are not limited to:<br />
-	Analog Mixed Signal Test<br />
-	Automatic Test Generation<br />
-	Built-In Self-Test<br />
-	Defect-Based Test<br />
-	Design and Synthesis for Testability<br />
-	Design for Electromagnetic Compatibility<br />
-	Design for Reliable Embedded Software<br />
-	Design Verification / Validation<br />
-	Economics of Test<br />
-	Fault Analysis and Diagnosis<br />
-	Fault Modeling and Simulation<br />
-	Fault-Tolerance in HW/SW<br />
-	Fault-Tolerant Architectures<br />
-	Memory Test and Repair<br />
- On-Chip Analytics and Lifecycle Management<br />
-	On-Line Testing<br />
-	Radiation / Electromagnetic Interference<br />
-	Hardening Techniques<br />
-	Software Fault-Tolerance<br />
-	System-on-Chip Test<br />
-	Test Resource Partitioning<br />
-	Yield Optimization<br />
-	Hardware Security<br />
    </base-section-heading>
    <!---
      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>
        </v-col>
      </v-row>
    --->
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({
      features: [
        {
          title: 'Pixel Perfect Design',
          icon: 'mdi-fountain-pen-tip',
        },
        {
          title: 'Retina Ready',
          icon: 'mdi-cellphone',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Easily Customizable',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'Image Parallax',
          icon: 'mdi-image-size-select-actual',
        },
        {
          title: 'Seo Optimized',
          icon: 'mdi-ice-pop',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
